export default __webpack_public_path__ + "static/Hero_05_Reliability_Resilience-1d3768b000c04d96e4c7e8fe52d92614.jpg";